const styles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  uploadSection: {
    marginTop: theme.spacing(2),
  },
})

export default styles
